module.exports = __webpack_public_path__ + "images/finish_setup.webp";